import React, { FC, useEffect } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const DropOffDateReturnField: FC = () => {
  const formApi = useFormApi();

  const { value: pickup_date_return } = useNonSpammyFieldState('pickup_date_return');

  useEffect(() => {
    if (pickup_date_return) {
      formApi.setValue('dropoff_date_return', pickup_date_return);
    }
  }, [pickup_date_return]);

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-drop-off-date-return">
      <DateField
        className={css.input}
        label={t('bookingDetails.dropoffDate')}
        minDate={pickup_date_return as Date}
        name="dropoff_date_return"
        showMonthDropdown
        showYearDropdown
        validate={notEmptyValidator}
      />
    </div>
  );
};

export default DropOffDateReturnField;
